import React, { Suspense } from "react";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import { AuthRoute } from "./auth.routes";

const Login = React.lazy(() => import("../screens/Login"));
const Home = React.lazy(() => import("../screens/Home"));
const Vendedores = React.lazy(() => import("../screens/Vendedores"));
const Clientes = React.lazy(() => import("../screens/Clientes"));
const DetalhesDeCliente = React.lazy(
  () => import("../screens/DetalhesDeCliente")
);
const Categorias = React.lazy(() => import("../screens/Categorias"));
const Tmkt = React.lazy(() => import("../screens/Tmkt"));
const DetalhesDeTmkt = React.lazy(() => import("../screens/DetalhesDeTmkt"));
const SolicitacoesDeTMKT = React.lazy(
  () => import("../screens/SolicitaçõesTmkt")
);
const DetalhesSolicitacaoDeTMKT = React.lazy(
  () => import("../screens/DetalhesSolicitaçãoTmkt")
);
const Integracoes = React.lazy(() => import("../screens/Integrações"));
const DetalhesProposta = React.lazy(
  () => import("../screens/DetalhesProposta")
);

const Routes: React.FC = () => {
  return (
    <BrowserRouter>
      <Suspense fallback={<></>}>
        <Switch>
          <Route path="/login" exact component={Login} />

          <AuthRoute
            path="/clientes/detalhes/:id"
            component={DetalhesDeCliente}
          />
          <AuthRoute
            path="/preclientes/detalhes/:id"
            component={DetalhesDeTmkt}
          />

          <AuthRoute
            path="/solicitacoestmkt/detalhes/:id"
            component={DetalhesSolicitacaoDeTMKT}
          />

          <AuthRoute path="/dashboard" component={Home} />
          <AuthRoute path="/vendedores" component={Vendedores} />
          <AuthRoute path="/clientes" component={Clientes} />
          <AuthRoute path="/categorias" component={Categorias} />
          <AuthRoute path="/preclientes" component={Tmkt} />
          <AuthRoute path="/solicitacoestmkt" component={SolicitacoesDeTMKT} />
          <AuthRoute path="/integracoes" component={Integracoes} />
          <AuthRoute
            path="/detalhesproposta/:id"
            component={DetalhesProposta}
          />

          <Route path="*" render={() => <Redirect to="/login" />} />
        </Switch>
      </Suspense>
    </BrowserRouter>
  );
};

export default Routes;
